module.exports = __webpack_public_path__ + "static/media/26UNRWA9.6dcd9838.jpg";